import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatTableDataSource } from '@angular/material';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { RelatorioService } from 'app/service/cliente/relatorio.service';
import { Observable } from 'rxjs';

@Component({
  selector: "app-node-user-dialog",
  templateUrl: "./node-user-dialog.component.html",
  styleUrls: ["./node-user-dialog.component.scss"],
})
export class NodeUserDialogComponent implements OnInit, AfterViewInit {
  @ViewChild("nodesPaginator", { read: MatPaginator })
  nodesPaginator: MatPaginator;
  @ViewChild("nodesAuthPaginator") nodesAuthPaginator: MatPaginator;
  @ViewChild("usersPaginator") usersPaginator: MatPaginator;
  @ViewChild("usersAuthPaginator") usersAuthPaginator: MatPaginator;

  displayedColumns = ["name", "action"];
  dispColumnsNdEdit = ["mode_btn", "name", "action"];
  usersOrNodes: any[] = [];

  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  dataSourceNodes = new MatTableDataSource<any>([]);
  dataSourceUsers = new MatTableDataSource<any>([]);
  dataSourceToEdit = new MatTableDataSource<any>([]);
  dataSourceUsersAuth = new MatTableDataSource<any>([]);

  isNodeEdit = false;
  isUserEdit = false;
  // nodes: any;
  isLoading = true;
  userId: any;
  typesUsersToSave: any[] = [];
  nodesToEdit: any[] = [];
  usersAuth: any[] = [];

  constructor(
    public _snackBar: MatSnackBar,
    public configFolderService: ConfigurarPastaServiceService,
    public relatorioService: RelatorioService,
    public dialogRef: MatDialogRef<NodeUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.isNodeEdit = this.data.isNodeEdit;
    this.isUserEdit = this.data.isUserEdit;
    this.usersOrNodes = this.data.data;

    if (this.isNodeEdit === true) {
      this.getUsuarios();
    } else if (this.isUserEdit === true) {
      // this.userId = this.data.element.id;
      this.getAlltipos();
    }

    // console.log(this.usersOrNodes)
  }

  ngAfterViewInit() {
    this.dataSourceNodes.paginator = this.nodesPaginator;
    // this.dataSourceToEdit.paginator = this.nodesAuthPaginator;
    this.dataSourceUsers.paginator = this.usersPaginator;
    // this.dataSourceUsersAuth.paginator = this.usersAuthPaginator;
  }

  getAlltipos() {
    this.configFolderService.getAllTipos().subscribe(
      (dados) => {
        this.dataSourceNodes.data = dados.map((el) => ({
          id: el.id,
          title: el.title,
          showOnlyToUser: false,
        }));
        this.getNodesByUser();
      },
      (err) => {
        this.isLoading = false;
        this.openSnackBar(
          "Ocorreu um erro ao buscar os Tipos Documentais",
          true
        );
        console.error(err);
        return;
      }
    );
  }

  getUsuarios() {
    this.relatorioService.getUsuariosPorCliente(this.data.clienteId).subscribe(
      (data) => {
        this.dataSourceUsers.data = data.map((el) => ({
          id: el.id,
          nome: el.nome,
        }));

        this.getUsersByNode();
      },
      (err) => {
        console.error(err);
        this.openSnackBar(
          "Erro ao buscar Usuários, tente novamente mais tarde",
          true
        );
        this.isLoading = false;
        return;
      }
    );
  }

  getNodesByUser() {
    this.configFolderService
      .getNodesByClientAndUser(this.data.clienteId, this.data.element.id)
      .subscribe(
        (nodes) => {
          if (nodes.length === 0) {
            this.openSnackBar(
              `Nenhum Tipo encontrado para o usuário ${this.data.element.nome}`,
              true
            );
          } else {
            nodes.forEach((e) => {
              this.addNodeToEdit(e);
            });
            // this.dataSourceNodes.data = this.dataSourceNodes.data;
          }
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          this.openSnackBar(
            "Ocorreu um erro ao buscar os Tipos por Usuário",
            true
          );
          console.error(err);
        }
      );
  }

  getUsersByNode() {
    this.configFolderService
      .getAuthUsersByClientAndNode(this.data.clienteId, this.data.element.id)
      .subscribe(
        (users) => {
          if (users.length === 0) {
            this.openSnackBar(
              "Nenhum usuário encontrado para este tipo Documental",
              true
            );
          } else {
            users.forEach((e) => {
              this.setUserAuth(e);
            });
            // this.dataSource.data
          }
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          this.openSnackBar(
            "Ocorreu um erro ao buscar usuários por tipo",
            true
          );
          console.error(err);
        }
      );
  }

  onChangeSelAll(check) {
    if (check) {
      this.dataSourceToEdit.data.forEach((el) => {
        el.showOnlyToUser = true;
      });
    } else {
      this.dataSourceToEdit.data.forEach((el) => {
        el.showOnlyToUser = false;
      });
    }
  }

  addNodeToEdit(item) {
    //copy
    let i = this.dataSourceNodes.data.findIndex((e) => e.id === item.id);
    this.dataSourceNodes.data.splice(i, 1);

    this.dataSourceNodes.data = this.dataSourceNodes.data;

    this.dataSourceToEdit.data.push(item);
    this.dataSourceToEdit.data = this.dataSourceToEdit.data;
  }

  removeItemToEdit(item) {
    let i = this.dataSourceToEdit.data.findIndex((e) => e.id === item.id);
    this.dataSourceToEdit.data.splice(i, 1);
    this.dataSourceToEdit.data = this.dataSourceToEdit.data;

    this.dataSourceNodes.data.push(item);
    this.dataSourceNodes.data = this.dataSourceNodes.data;
  }

  setUserAuth(user) {
    let i = this.dataSourceUsers.data.findIndex((e) => e.id === user.id);
    this.dataSourceUsers.data.splice(i, 1);
    this.dataSourceUsers.data = this.dataSourceUsers.data;

    this.dataSourceUsersAuth.data.push(user);
    this.dataSourceUsersAuth.data = this.dataSourceUsersAuth.data;
  }

  removeUserAuth(user) {
    let i = this.dataSourceUsersAuth.data.findIndex((e) => e.id === user.id);
    this.dataSourceUsersAuth.data.splice(i, 1);
    this.dataSourceUsersAuth.data = this.dataSourceUsersAuth.data;

    this.dataSourceUsers.data.push(user);
    this.dataSourceUsers.data = this.dataSourceUsers.data;
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }

  saveUsersAuth() {
    this.typesUsersToSave = [];
    this.isLoading = true;

    if (this.isNodeEdit === true) {
      this.dataSourceUsersAuth.data.forEach((user) => {
        const typeUserAuth = {
          nodeId: this.data.element.id,
          clientId: Number(this.data.clienteId),
          userId: user.id,
          showOnlyToUser: this.data.element.showOnlyToUser,
        };
        this.typesUsersToSave.push(typeUserAuth);
      });

      this.callSaveMethod(
        this.configFolderService.editUsersByNode(
          this.typesUsersToSave,
          this.data.clienteId,
          this.data.element.id
        )
      );
    } else if (this.isUserEdit === true) {
      this.dataSourceToEdit.data.forEach((node) => {
        const typeUserAuth = {
          nodeId: node.id,
          clientId: Number(this.data.clienteId),
          userId: this.data.element.id,
          showOnlyToUser: node.showOnlyToUser,
        };
        this.typesUsersToSave.push(typeUserAuth);
      });
      // console.log(this.typesUsersToSave);
      this.callSaveMethod(
        this.configFolderService.editNodesByUser(
          this.typesUsersToSave,
          this.data.clienteId,
          this.data.element.id
        )
      );
    }
  }

  callSaveMethod(method: Observable<any[]>) {
    method.subscribe(
      () => {
        this.isLoading = false;
        this.openSnackBar("Alterações salvas com sucesso!", false);
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar("Ocorreu um erro ao salvar as alterações", true);
      }
    );
  }

  aplicarFiltro(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();

    if (this.isNodeEdit === true) {
      this.dataSourceUsers.filter = filter;
    } else if (this.isUserEdit === true) {
      this.dataSourceNodes.filter = filter;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/node-user-dialog/node-user-dialog.component.ts